/* @flow */

export type IconName = string;

function Icon({
  name,
  style,
  className,
  ...props
}: {
  name: IconName,
  style?: ?Object,
  className?: ?string,
  props?: ?Object,
}) {
  // eslint-disable-next-line import/no-dynamic-require
  const { default: render } = require(`../../../assets/images/icons/${name}.js`);
  return render({ alt: name, style, className, ...props });
}

export default Icon;



// WEBPACK FOOTER //
// ./src/ui/components/core/Icon.js